<template>
  <div class="result">
    <div class="resultBg">
      <div class="resultRightBg"></div>
    </div>
    <div class="box">
      <div class="resultContent">
        <div class="resultContentHeader" :class="resultLevelClass"></div>
        <div class="textBox">
          <div class="dataLeft">
            <div class="title">答对</div>
            <div class="num">
              <span class="successCount">{{ totalValid }}</span
              >/<span>{{ totalNum }}</span>
            </div>
          </div>
          <div class="line"></div>
          <div class="score">
            <div class="scoreTitle">综合得分</div>
            <div class="scoreNum">{{ totalScore }}<span>分</span></div>
          </div>
          <div class="line"></div>
          <div class="dataRight">
            <div class="title">用时</div>
            <div class="time">
              {{ Math.floor(totalTime / 60) }}分{{ totalTime % 60 }}秒
            </div>
          </div>
        </div>

        <div class="comment">
          <span v-if="isGold">太棒了，为您感到高兴，继续保持哦！</span>
          <span v-if="isSilver">稳扎稳打！为您点赞，继续加油哦！</span>
          <span v-if="isCopper">别灰心！参与就很棒！下次会更好！</span>
        </div>
      </div>
      <div class="resultData">
        <div class="reportCard" v-if="hasDimStats">
          <div class="reportHeader">{{ reportDisplayTitle }}</div>
          <div class="reportBody">
            <div class="reportRow" v-for="item in dimStats" :key="item._key">

              <div class="rowBar">
                <div class="rowTitle">{{ item.name }}</div>
                <div class="rowValue">{{ item.ratioPercent }}</div>
              </div>
              <div class="rowBar">
                <div class="rowTrack">
                  <div
                    class="rowFill"
                    :style="{ width: getProgressWidth(item.ratioPercent) }"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="emptyTip" v-else>暂无维度统计数据</div>
      </div>
      <div class="btn">
        <div
          class="goIndex"
          :class="{ active: isIndex }"
          @mousedown="handlePressIndex(true)"
          @mouseup="handlePressIndex(false)"
          @mouseleave="handlePressIndex(false)"
          @touchstart="handlePressIndex(true)"
          @touchend="handlePressIndex(false)"
          @touchcancel="handlePressIndex(false)"
          @click="goIndex"
        >
          返回首页
        </div>
        <div
          class="goEvaluation"
          :class="{ active: isEvaluation }"
          @mousedown="handlePressEvaluation(true)"
          @mouseup="handlePressEvaluation(false)"
          @mouseleave="handlePressEvaluation(false)"
          @touchstart="handlePressEvaluation(true)"
          @touchend="handlePressEvaluation(false)"
          @touchcancel="handlePressEvaluation(false)"
          @click="goEvaluation"
        >
          再次测评
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { testReport } from '@/api/index'

export default {
  name: 'resultPage',
  data () {
    return {
      totalScore: 0,
      totalTime: 0,
      totalValid: 0,
      totalNum: 0,
      totalRatio: 0,
      reportTitle: '',
      dimStats: [],
      historyList: [],
      loadingReport: false,
      isIndex: false,
      isEvaluation: false,
      isGold: false,
      isSilver: false,
      isCopper: false,
      resultLevelClass: '' // 绑定到 class
    }
  },
  computed: {
    reportDisplayTitle () {
      return this.reportTitle || '测评报告'
    },
    totalAccuracy () {
      if (this.totalRatio !== undefined && this.totalRatio !== null) {
        return Math.round(Math.min(1, Math.max(0, this.totalRatio)) * 100)
      }
      if (this.totalNum <= 0) return 0
      return Math.round((this.totalValid / this.totalNum) * 100)
    },
    hasDimStats () {
      return Array.isArray(this.dimStats) && this.dimStats.length > 0
    }
  },
  created () {
    this.initializeFromQuery(this.$route.query || {})
    this.fetchReport()
  },

  methods: {
    initializeFromQuery (query = {}) {
      const {
        totalRatio,
        totalScore,
        useTime,
        totalTime,
        successCount,
        totalCount,
        totalValid,
        totalNum,
        title
      } = query
      if (totalTime !== undefined) {
        this.totalTime = Math.max(
          0,
          Math.floor(this.normalizeNumber(totalTime, this.totalTime))
        )
      }
      if (useTime !== undefined && this.totalTime === 0) {
        this.totalTime = Math.max(0, Math.floor(this.normalizeNumber(useTime, this.totalTime)))
      }
      const validSource = totalValid !== undefined ? totalValid : successCount
      if (validSource !== undefined) {
        this.totalValid = Math.max(
          0,
          Math.floor(this.normalizeNumber(validSource, this.totalValid))
        )
      }
      const totalSource = totalNum !== undefined ? totalNum : totalCount
      if (totalSource !== undefined) {
        this.totalNum = Math.max(
          0,
          Math.floor(this.normalizeNumber(totalSource, this.totalNum))
        )
      }
      if (title) {
        this.reportTitle = title
      }
      if (totalRatio !== undefined) {
        this.totalRatio = Math.max(0, Number(totalRatio))
      } else if (this.totalNum > 0) {
        this.totalRatio = this.totalValid / this.totalNum
      }
      if (this.totalRatio !== undefined && this.totalRatio !== null) {
        this.totalScore = Math.round(Math.min(1, Math.max(0, this.totalRatio)) * 100)
      } else if (totalScore !== undefined) {
        this.totalScore = this.normalizeNumber(totalScore)
      }
      this.updateResultLevel()
    },
    normalizeNumber (value, fallback = 0) {
      const num = Number(value)
      return Number.isFinite(num) ? num : fallback
    },
    async fetchReport () {
      const query = this.buildReportQuery()
      if (!query) {
        return
      }
      this.loadingReport = true
      try {
        const res = await testReport(query)
        const payload = res && res.data ? res.data : res
        if (payload && payload.code === 200 && payload.data) {
          this.applyReportData(payload.data)
        } else {
          console.warn('未获取到测评报告', payload)
        }
      } catch (error) {
        console.error('获取测评报告失败：', error)
      } finally {
        this.loadingReport = false
      }
    },
    buildReportQuery () {
      const testCode = this.$route?.query?.testCode
      if (!testCode) {
        return null
      }
      return { testCode }
    },
    applyReportData (report) {
      if (!report) return
      const {
        totalValid,
        totalNum,
        totalTime,
        totalRatio,
        title,
        dimStats = [],
        history = []
      } = report
      if (title) {
        this.reportTitle = title
      }
      if (totalValid !== undefined) {
        this.totalValid = Math.max(0, this.normalizeNumber(totalValid, 0))
      }
      if (totalNum !== undefined) {
        this.totalNum = Math.max(0, this.normalizeNumber(totalNum, 0))
      }
      if (totalTime !== undefined) {
        this.totalTime = Math.max(0, Math.floor(this.normalizeNumber(totalTime, 0)))
      }
      if (totalRatio !== undefined) {
        this.totalRatio = Math.max(0, Number(totalRatio))
      } else if (this.totalNum > 0) {
        this.totalRatio = this.totalValid / this.totalNum
      }
      this.totalScore = Math.round(Math.min(1, Math.max(0, this.totalRatio || 0)) * 100)
      this.dimStats = Array.isArray(dimStats)
        ? dimStats.map((item, index) => {
          const ratioValue = Number(item.ratio || 0)
          return {
            ...item,
            _key: item.dim || index,
            ratioPercent: Math.round(Math.min(1, Math.max(0, ratioValue)) * 100),
            valid: this.normalizeNumber(item.valid, 0),
            total: this.normalizeNumber(item.total, 0)
          }
        })
        : []
      this.historyList = Array.isArray(history) ? history : []
      this.updateResultLevel()
    },
    updateResultLevel () {
      const score = Math.round(
        Number.isFinite(Number(this.totalScore)) ? Number(this.totalScore) : 0
      )
      this.isGold = false
      this.isSilver = false
      this.isCopper = false
      if (score >= 90) {
        this.isGold = true
        this.resultLevelClass = 'gold'
      } else if (score >= 80 && score < 90) {
        this.isSilver = true
        this.resultLevelClass = 'silver'
      } else {
        this.isCopper = true
        this.resultLevelClass = 'copper'
      }
    },
    getProgressWidth (percent) {
      const value = Number(percent)
      if (!Number.isFinite(value)) {
        return '0%'
      }
      return `${Math.min(100, Math.max(0, value))}%`
    },
    goIndex () {
      this.$router.push('/')
    },
    goEvaluation () {
      this.$router.push('/evaluation')
    },
    handlePressIndex (state) {
      this.isIndex = state
    },
    handlePressEvaluation (state) {
      this.isEvaluation = state
    }
  }
}
</script>

<style scoped lang="less">
.result {
  width: 100vw;
  height: 100vh;
  background-color: #eeeeee;
}
.resultBg {
  position: relative;
  height: 30vh;
  background: linear-gradient(
    180deg,
    rgba(172, 219, 255, 1),
    rgba(255, 255, 255, 0) 100%
  );
  .resultRightBg {
    position: absolute;
    right: 0px;
    width: 450px;
    height: 291px;
    background: url("@/assets/resultRightBg.png") no-repeat center / 100% 100%;
  }
}
.box {
  position: absolute;
  top: 6.5vh;
  left: 50%;
  transform: translateX(-50%);
}
.resultContent {
  border-radius: 40px;
  box-shadow: 0px 20px 30px 0px rgba(89, 113, 173, 0.05);
  background: rgba(255, 255, 255, 1);
  font-family: Alibaba-PuHuiTi-Regular;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 20px;
  .resultContentHeader.gold {
    width: 687px;
    height: 154px;
    background: url("@/assets/gold.png") no-repeat center / 100% 100%;
  }
  .resultContentHeader.silver {
    width: 687px;
    height: 154px;
    background: url("@/assets/silver.png") no-repeat center / 100% 100%;
  }
  .resultContentHeader.copper {
    width: 687px;
    height: 154px;
    background: url("@/assets/copper.png") no-repeat center / 100% 100%;
  }
  .textBox {
    display: flex;
    align-items: flex-end;
    width: 100%;
    justify-content: space-evenly;
  }
  .score {
    margin-top: 20px;
    text-align: center;
    .scoreTitle {
      font-size: 38px;
    }
    .scoreNum {
      font-size: 64px;
      color: #f5683a;
      font-weight: 700;
      span {
        font-size: 38px;
      }
    }
  }
  .dataLeft {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 30%;
    font-size: 38px;
    .num {
      margin-bottom: 10px;
      font-weight: 700;
      font-size: 40px;
      .successCount {
        color: #f56d1f;
      }
    }
  }
  .line {
    width: 3px;
    height: 90px;
    background-color: rgba(233, 233, 233, 1);
  }
  .dataRight {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 38px;
    width: 30%;
    .time {
      color: #f5683a;
      font-weight: 700;
      margin-bottom: 5px;
    }
  }
  .comment {
    position: relative;
    margin-top: 25px;
    margin-bottom: 25px;
    text-align: center;
    font-size: 38px;
    border-radius: 15px;
    padding: 20px 5px;
    box-shadow: 0px 5px 9px 0px rgba(35, 76, 109, 0.05);
    background: rgba(255, 242, 224, 1);
    color: #f56d1f;
  }
  .comment::after {
    content: " ";
    display: block;
    position: absolute;
    left: 50%;
    top: -40px;
    transform: translate(-50%);
    width: 0px;
    height: 0px;
    border: 20px solid transparent; /*以下四个样式对应四种三角形，任选其一即可实现*/
    /* border-top-color:lightseagreen; */
    /* border-left-color:lightseagreen; */
    /* border-right-color:lightseagreen; */
    border-bottom-color: #fdf2e1;
  }
}
.resultData {
  display: flex;
  justify-content: center;
  border-radius: 28px;
  background: rgba(255, 255, 255, 1);
  // padding: 28px 36px;
  box-shadow: 0 16px 36px 0 rgba(89, 113, 173, 0.08);
  // width: 687px;
    margin: 20px 20px 0px;
}
.reportCard {
  width: 100%;
  background: rgba(255, 255, 255, 1);
  border-radius: 28px;
  box-shadow: inset 0 0 0 1px rgba(200, 214, 255, 0.4);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.reportHeader {
  padding: 16px 0;
  text-align: center;
  font-size: 35px;
  font-weight: 700;
  background: rgba(227, 235, 255, 1);
  color: rgba(20, 119, 231, 1);
}
.reportBody {
  padding: 40px ;
  display: flex;
  flex-direction: column;
  gap: 28px;
}
.reportRow {
  display: flex;
  flex-direction: column;
  gap: 14px;
  font-size: 28px;
  color: #44537a;
  margin-top: 30px;
  &:first-child {
    margin-top: 0px;
  }
}
.rowTitle {
    font-size: 32px;
  font-weight: 600;
}
.rowBar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}
.rowTrack {
  flex: 1;
  height: 12px;
  border-radius: 6px;
  background: rgba(226, 233, 248, 1);
  overflow: hidden;
  position: relative;
}
.rowFill {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  border-radius: 6px;
  background: linear-gradient(270.00deg, rgba(71, 135, 255, 1),rgba(81, 223, 255, 1) 100%);
  transition: width 0.3s ease;
}
.rowValue {
  min-width: 60px;
  text-align: right;
  font-size: 32px;
  font-weight: 700;
  // color: #2f56d7;
}
.emptyTip {
  text-align: center;
  font-size: 30px;
  color: #999;
  padding: 40px 0;
  width: 100%;
}
.btn {
  // margin-top: 10px;
  display: flex;
  .goIndex {
    width: 264px;
    height: 80px;
    font-family: Alibaba-PuHuiTi-Regular;
    font-size: 40px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    margin-top: 40px;
    background: url("@/assets/goIndex.png") no-repeat center / 100% 100%;
  }
  .goIndex.active {
    color: #c2c2c2;
    background: url("@/assets/goIndexOver.png") no-repeat center / 100% 100%;
  }
  .goEvaluation {
    width: 264px;
    height: 80px;
    font-family: Alibaba-PuHuiTi-Regular;
    font-size: 40px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    margin-top: 40px;
    background: url("@/assets/goEvaluation.png") no-repeat center / 100% 100%;
  }
  .goEvaluation.active {
    color: #c2c2c2;
    background: url("@/assets/goEvaluationOver.png") no-repeat center / 100%
      100%;
  }
}
</style>
